import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { DomainAggregationResponse } from '@/shared/api/openmetadata/types';

/**
 * 도메인 집계 데이터를 가져오는 함수
 *
 * @description
 * 전체 데이터 자산에서 도메인별 문서 개수를 집계합니다.
 * 검색 페이지 초기 로딩 시 한 번만 호출됩니다.
 */
export const fetchDomainAggregations = async (): Promise<DomainAggregationResponse> => {
  const query = {
    query: {
      bool: {
        must: [
          {
            match: {
              deleted: false,
            },
          },
        ],
      },
    },
  };

  const response = await openMetadataApiClient.get<DomainAggregationResponse>('/search/aggregate', {
    params: {
      index: 'dataAsset',
      field: 'domains.name.keyword',
      value: '.*',
      q: JSON.stringify(query),
    },
  });

  return response.data;
};
